import { atom } from "recoil";
import { IDVRType } from "../types";

export const addStateDVRType = atom({
  key: "addStateDVRType",
  default: false,
});
export const editStateDVRType = atom({
  key: "editStateDVRType",
  default: false,
});
export const rowEditDVRType = atom<IDVRType | undefined>({
  key: "rowEditDVRType",
  default: undefined,
});

export const selectedRowsStateDVRType = atom<IDVRType[]>({
  key: "selectedRowsStateDVRType",
  default: [],
});

export const dvrTypeFilterText = atom({
  key: "dvrTypeFilterText",
  default: "",
});

export const dvrTypeFetching = atom({
  key: "dvrTypeFetching",
  default: true,
});

export const dvrTypeReFetching = atom({
  key: "dvrTypeReFetching",
  default: false,
});
